import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {useDispatch, useSelector} from "react-redux";
import {resetVideo} from "../../slices/video";
import {selectUser} from "../../slices/profile";
import {incrementContentStatsViews} from "../../api/contentStats";
import {ContentType} from "../../db/models/content";

interface Props {
    video: ContentType;
}

const FullScreenVideo: React.FC<Props> = ({video}) => {
    const videoRef = useRef<any>(null);
    const [playing, setPlaying] = useState(true);
    const dispatch = useDispatch();
    const user = useSelector(selectUser);

    useEffect(() => {
        if (!user) return;
        document.body.style.overflowY = "hidden";

        if (!user?.demo)
            incrementContentStatsViews(video.id)
                .then(() => {
                })
                .catch((error) => console.error(error));
    }, [user]);

    const handlePlayPause = (event) => {
        event.stopPropagation();

        if (videoRef && videoRef.current) {
            if (playing) {
                (videoRef.current as any).pause();
            } else {
                (videoRef.current as any).play();
            }
            setPlaying(!playing);
        }
    };

    const handleBack = () => {
        document.body.style.overflowY = "unset";
        dispatch(resetVideo());
    };

    return (
        <div className="fullScreenVideo">
            <button onClick={handleBack}>
                <ArrowBackIcon/>
            </button>
            <video
                width="100%"
                height="100%"
                controls={true}
                ref={videoRef}
                controlsList="nodownload"
                onClick={(e) => handlePlayPause(e)}
            >
                <source src={video.sources?.[0]}/>
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default FullScreenVideo;
